module.exports = __webpack_public_path__ + "static/ruth-37df16ad5607262f0c33abc602659536.jpg";